import React from "react";
import { useTranslation } from "react-i18next";
import "./clientTheme.css";
import "./AppStoreBadges.css";

const APP_STORE_URL = "https://apps.apple.com/us/app/salatty/id6799667457";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.mohammad1998a.bigmarket";

export default function AppStoreBadges({ compact = false }) {
  const { t } = useTranslation("mainPage");

  return (
    <div className={`app-store-badges${compact ? " app-store-badges-compact" : ""}`}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="app-store-badge"
        aria-label={t("downloadOnAppStore")}
      >
        <svg viewBox="0 0 24 24" className="app-store-badge-icon" aria-hidden="true">
          <path
            fill="currentColor"
            d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"
          />
        </svg>
        <span className="app-store-badge-text">
          <span className="app-store-badge-small">{t("downloadOnThe")}</span>
          <span className="app-store-badge-large">App Store</span>
        </span>
      </a>
      <a
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="app-store-badge"
        aria-label={t("getItOnGooglePlay")}
      >
        <svg viewBox="0 0 512 512" className="app-store-badge-icon" aria-hidden="true">
          <path
            fill="#00d2ff"
            d="M325.3 234.3L104.7 13.7C99.7 8.7 92.6 6 85.3 6c-5.4 0-10.2 1.6-14.3 4.6l217 217.6z"
          />
          <path
            fill="#00f076"
            d="M288.1 271.5l-217-217.6c-3.7 4.6-5.7 10.5-5.7 16.9v370.5c0 6.4 2 12.3 5.7 16.9l217-217.6z"
          />
          <path
            fill="#ffcf00"
            d="M104.7 498.3l220.6-220.6-37.2-37.2-217 217.6c5 5 11 7.5 16.6 7.5 5.4 0 10.6-2.1 17-7.3z"
          />
          <path
            fill="#ff3a44"
            d="M420.8 231.6l-58.3-33.6-40.5 40.6 40.5 40.6 58.5-33.7c9.4-6.6 14.4-15 14.4-23.6s-5.1-16.9-14.6-23.3z"
          />
        </svg>
        <span className="app-store-badge-text">
          <span className="app-store-badge-small">{t("getItOn")}</span>
          <span className="app-store-badge-large">Google Play</span>
        </span>
      </a>
    </div>
  );
}
